import Layout from '@/container/Full'

const HostingAlerts = () => import(/* webpackChunkName: "alerts" */ '@/views/services/alerts/AlertsView')
const Alert = () => import(/* webpackChunkName: "alerts" */ '@/views/alerts/AlertView')

const routes = [
  {
    path: '/alerts',
    component: Layout,
    children: [
      {
        path: '',
        name: 'hosting_alerts',
        component: HostingAlerts,
        meta: {
          access_type: 'authorized',
        },
      },
      {
        path: '/alerts/:alertId',
        name: 'alert',
        props: true,
        component: Alert,
        meta: {
          access_type: 'authorized'
        },
      },
    ],
  },
]

export default routes
